export default function missingHandler(_, key) {
  // generate a fallback for missing api texts
  if (key.substr(0, 4) === '_api') {
    const fallback = key.split('.').pop()
    return fallback[0]?.toUpperCase() + fallback.substring(1)
  }
}
